import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import { ReactNode } from "react";

import { IConsumption } from '~/providers/interfaces';
import { formatDate, formatNumberToThousands } from "~/utils/utils";

interface IRowItem {
	id: string;
	day: string;
	[key: string]: string | number;
}

function sortServices(items: Array<string>): Array<string> {
	items.sort((aItem: string, bItem: string) => aItem.localeCompare(bItem));

	return items;
}

export function processConsumpitonsDays(title: string = "Den", consumptions: Array<IConsumption>, isCzech: boolean): {
	columns: GridColDef[];
	rows: Array<IRowItem>;
	pinnedRows: Array<Array<string>>;
} {
	const services = [...new Set(consumptions.map(consumption => consumption.service))];
	const days = [...new Set(consumptions.map(consumption => consumption.date))];
	const serviesCallCount = {};
	const serviesCreditsCount = {};
	const temporaryRows: any = {};

	services.forEach(serv => {
		serviesCreditsCount[serv] = 0;
		serviesCallCount[serv] = 0;
	});
	sortServices(services);
	days.forEach(day => {
		temporaryRows[day] = services.reduce((accumulator, value) => ({ ...accumulator, [value]: 0 }), {});
	});
	consumptions.forEach(consumption => {
		temporaryRows[consumption.date][consumption.service] += consumption.count;
		serviesCallCount[consumption.service] += consumption.count;
		serviesCreditsCount[consumption.service] += consumption.count * consumption.callPrice;
	});

	const rows = days.map(day => ({
		day,
		id: day,
		...temporaryRows[day],
	}));
	const sumCallLine = ["Celkem volání"];
	const sumCreditLine = ["Celkem kreditů"];
	const pinnedRows = [sumCallLine, sumCreditLine];

	services.forEach(serv => {
		sumCallLine.push(formatNumberToThousands(serviesCallCount[serv]));
		sumCreditLine.push(formatNumberToThousands(serviesCreditsCount[serv]));
	});

	function renderFormatCell(data: GridCellParams): ReactNode {
		const row: IRowItem = data.row;

		if (row.sumCall || row.sumCredits) {
			return <strong>{ row.day }</strong>;
		}

		return formatDate(new Date(data.id), isCzech);
	}

	function renderServiceCell(data: GridCellParams): ReactNode {
		const row: IRowItem = data.row;

		return formatNumberToThousands(row[data.field] as number);
	}

	return {
		columns: [
			{
				field: 'day',
				headerName: title,
				description: title,
				renderCell: renderFormatCell,
			},
			...services.map(service => ({
				field: service,
				headerName: service,
				description: service,
				renderCell: renderServiceCell,
			})),
		],
		rows,
		pinnedRows,
	};
}
